import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ForcePasswordChange } from "@/components/ForcePasswordChange";

const Loader = () => (
  <div className="flex min-h-screen items-center justify-center bg-background">
    <div className="h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
  </div>
);

export function ProtectedRoute({ children, staffOnly }) {
  const { user, isStaff } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForcePasswordChange />;
  // Only bounce a fully-loaded, confirmed non-staff user. A logged-in user object
  // always carries its role, so staff (incl. platform_owner) never get redirected.
  if (staffOnly && user && user.role !== undefined && !isStaff) {
    return <Navigate to="/app" replace />;
  }
  return children;
}
